import { FC, useEffect } from 'react';
import cx from 'classnames/bind';
import { ReactSVG } from 'react-svg';

import CigaretteImage from '@/assets/cigarette.svg';
import Capsule1 from '@/assets/capsule1.svg';
import Capsule2 from '@/assets/capsule2.svg';
import Tobacco from '@/assets/tobacco.svg';
import type { IPack } from '@/types/pack';
import type { IIdsSelectedCheckboxes } from '@/types/idsSelectedCheckboxes';
import { cigaretteStyle, formats } from '@/components/Game/Cigarette/constants';

import styles from './Cigarette.module.scss';

interface CigaretteProps {
  idsSelectedCheckboxes: IIdsSelectedCheckboxes;
  currentSlideIndex: any;
  pack: IPack;
}

const cn = cx.bind(styles);

const Cigarette: FC<CigaretteProps> = ({
  idsSelectedCheckboxes,
  currentSlideIndex,
  pack,
}) => {
  const cigarette = formats[currentSlideIndex.formats];

  const color1 = document.querySelector('[data-characteristic="color1"]')!;
  const color1Extra = document.querySelector(
    '[data-characteristic="color1Extra"]',
  )!;
  const color2 = document.querySelector('[data-characteristic="color2"]')!;
  const color2Extra = document.querySelector(
    '[data-characteristic="color2Extra"]',
  )!;

  const capsule1 = document.querySelector('[data-characteristic="capsule1"]')!;
  const capsule2 = document.querySelector('[data-characteristic="capsule2"]')!;
  const bag = document.querySelector('[data-characteristic="bag"]');
  const tobacco = document.querySelector('[data-characteristic="tobacco"]');
  const filter = document.querySelectorAll('[data-characteristic="filter"]')!;

  useEffect(() => {
    // Выделение мешки табака на изображении сигареты
    if (bag && tobacco) {
      if (currentSlideIndex.bag) {
        bag.setAttribute('fill', '#682800');
        tobacco.setAttribute('display', 'block');
      } else {
        bag.removeAttribute('fill');
        tobacco.setAttribute('display', 'none');
      }
    }

    // Выделение фильтра на изображении сигареты
    if (currentSlideIndex.filter) {
      [...filter].map((item) => item.setAttribute('fill', '#ffab90'));
    } else {
      [...filter].map((item) => item.removeAttribute('fill'));
    }
  }, [currentSlideIndex]);

  useEffect(() => {
    // Выбор цветов для первой капсулы
    const colorsCapsule1 = pack?.capsules.find(
      ({ id }) => idsSelectedCheckboxes.capsules[0] === id,
    );
    // Отображение первой капсулы, если цвет выбран
    if (capsule1) {
      // TODO:: проверить
      capsule1.setAttribute(
        'display',
        colorsCapsule1?.firstColor ? 'block' : 'none',
      );
    }
    // Добавление цвета для первой капсулы
    if (color1 && colorsCapsule1?.firstColor) {
      color1?.setAttribute('fill', colorsCapsule1.firstColor);
    }
    // Добавление добавочного цвета для первой капсулы
    if (colorsCapsule1?.secondColor) {
      color1Extra?.setAttribute('fill', colorsCapsule1.secondColor);
    }

    // Выбор цветов для второй капсулы
    const colorsCapsule2 = pack?.capsules.find(
      ({ id }) => idsSelectedCheckboxes.capsules[1] === id,
    );
    // Отображение второй капсулы, если цвет выбран
    if (capsule2) {
      capsule2.setAttribute(
        'display',
        colorsCapsule2?.firstColor ? 'block' : 'none',
      );
    }
    // Добавление цвета для второй капсулы
    if (colorsCapsule2?.firstColor) {
      color2?.setAttribute('fill', colorsCapsule2.firstColor);
    }
    // Добавление добавочного цвета для второй капсулы
    if (colorsCapsule2?.secondColor) {
      color2Extra?.setAttribute('fill', colorsCapsule2.secondColor);
    }
  }, [idsSelectedCheckboxes]);

  useEffect(() => {
    const cigaretteSvg = document.querySelector(
      '[data-characteristic="cigarette"]',
    );

    // Смена ширины и высоты изображения сигареты
    if (cigaretteSvg) {
      cigaretteSvg.setAttribute('width', cigaretteStyle[cigarette].width);
      cigaretteSvg.setAttribute('height', cigaretteStyle[cigarette].height);
    }
  }, [currentSlideIndex]);

  return (
    <div className={cn('svg-wrapper')}>
      <div className={cn('svg-wrapp')}>
        <ReactSVG className={cn('svg-cigarette')} src={CigaretteImage} />
        <ReactSVG className={cn('svg-tobacco')} src={Tobacco} />
        <ReactSVG
          className={cn('svg-capsule', 'svg-capsule-first')}
          src={Capsule1}
        />
        <ReactSVG
          className={cn('svg-capsule', 'svg-capsule-second')}
          src={Capsule2}
        />
      </div>
    </div>
  );
};

export default Cigarette;
